// Core
import { create } from "zustand";
import { devtools } from "zustand/middleware";

export type ConfigType = {
  country: string | null;
  cashbackList: string[];

  getCountry: () => string | null;
  setCountry: (country: string | null) => void;

  getCashbackList: () => string[];
  setCashbackList: (list: string[]) => void;
};

const ConfigStore = create(
  devtools<ConfigType>((_set, _get) => ({
    country: null,
    cashbackList: [],

    getCountry: () => _get().country,
    setCountry: (country: string | null) => _set({ country }),

    getCashbackList: () => _get().cashbackList,
    setCashbackList: (list: string[]) => _set({ cashbackList: list }),
  })),
);

export default ConfigStore;
